import { Edit } from "lucide-react";
import React from "react";
import { Button } from "./button";

const EditButton = ({
  editing = false,
  onChange,
  className = "",
  ...props
}) => {
  const handleClick = () => {
    if (onChange) onChange(!editing);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      className={`flex items-center gap-2 border-[#0052FD] text-[#0052FD] font-[600] text-[16px] ${className}`}
      {...props}
    >
      <Edit className="h-4 w-4" />
      Edit
    </Button>
  );
};

export default EditButton;
